import { createApp } from 'vue'
import FlowEditModal from './FlowEditModal'

const el = '.kb-component--flow-edit-modal'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FlowEditModalDOM) => {
            const component = createApp(FlowEditModal).use(Store)
            component.mount(FlowEditModalDOM)
        })
    }
}
